import moment from 'moment-timezone';
import React, { ComponentType, RefObject } from 'react';
import styled from 'styled-components';
import { Timezone16 } from 'ui/icons/aurora/16px/Timezone16';
import { body2, colors, spacing } from 'ui/theme';
import { BaseOption, SelectValueDisplayProps } from 'ui/selects/types';

const TriggerWrapper = styled.button<Partial<SelectValueDisplayProps>>`
  display: flex;
  flex: 1 1 auto;
  gap: ${spacing.half};
  ${body2};
  color: ${(props) => {
    if (props.isDisabled) return colors.textDisabled;
    return props.isOpen ? colors.purple100 : colors.textPrimary;
  }};
  outline: none;
  border: none;
  align-items: center;
  background: ${colors.white};
  border-radius: ${spacing.quarter};
  padding: ${spacing.half} ${spacing.threeQuarter};
  margin: ${spacing.single};

  &:focus-within {
    color: ${(props) => {
      if (props.isDisabled) return colors.textDisabled;
      return colors.purple100;
    }};
  }
`;

export const TimeZoneTrigger: ComponentType<
  React.PropsWithChildren<SelectValueDisplayProps<string>>
> = React.forwardRef(
  (
    {
      selectedOptions = [],
      isOpen = false,
      toggleDropdown,
      isNonInteractive = false,
      isDisabled = false,
    }: SelectValueDisplayProps,
    ref,
  ) => {
    const [selectedOption = {} as BaseOption<string>] = selectedOptions;

    return (
      <TriggerWrapper
        aria-expanded={isOpen}
        isOpen={isOpen}
        isDisabled={isDisabled}
        onClick={(e) => {
          if (!isNonInteractive) {
            e.stopPropagation();
            toggleDropdown();
          }
        }}
        data-test="time-zone-picker-toggle"
        ref={ref as RefObject<HTMLButtonElement>}
      >
        <Timezone16 />
        {moment.tz(selectedOption.value).zoneAbbr()}
      </TriggerWrapper>
    );
  },
);
